import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthCard, PrimaryButton } from "@/components/AuthCard";
import { useI18n } from "@/i18n/I18nProvider";
import { api, errorKey } from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) return setError("validation.email");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(errorKey(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard testId="forgot" title={t("auth.forgotTitle")} subtitle={t("auth.forgotSubtitle")}>
      {sent ? (
        <div data-testid="forgot-success" role="status" className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
          <MailCheck className="mb-2 h-6 w-6" />
          {t("auth.forgotSent")}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" noValidate>
          <div className="space-y-2">
            <Label htmlFor="forgot-email">{t("settings.email")}</Label>
            <Input id="forgot-email" type="email" inputMode="email" autoComplete="email" data-testid="forgot-email-input"
              value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 bg-white text-base" />
          </div>
          {error && <p data-testid="forgot-error" role="alert" className="text-sm font-medium text-red-600">{t(error)}</p>}
          <PrimaryButton busy={busy} testId="forgot-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} {t("auth.forgotSubmit")}
          </PrimaryButton>
          <p className="text-xs text-gray-500">{t("auth.employeeResetNote")}</p>
        </form>
      )}
    </AuthCard>
  );
}
